import { Pipe, PipeTransform } from '@angular/core';

type GalleryMedia = {
  small_file: string;
  file: string;
};

@Pipe({
  name: 'responsiveImages',
})
export class ResponsiveImagesPipe implements PipeTransform {
  transform(value: GalleryMedia[], typeUrl?: string): any {
    if (typeUrl) {
      if (value.find((x) => x.small_file)?.small_file) {
        return 'galleriesSmallFile';
      } else {
        return 'gallerie';
      }
    } else {
      const image =
        value.find((x) => x.small_file)?.small_file ||
        value.find((x) => x.file)?.file;

      return {
        file: image,
        small_file: '',
      };
    }
  }
}
